/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignVolunteerRequest,
  ClientVolunteerAssignmentResponse,
  ProblemDetails,
} from '../models/index';
import {
    AssignVolunteerRequestFromJSON,
    AssignVolunteerRequestToJSON,
    ClientVolunteerAssignmentResponseFromJSON,
    ClientVolunteerAssignmentResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface AssignVolunteerToClientRequest {
    clientId: string;
    assignVolunteerRequest: AssignVolunteerRequest;
}

export interface GetClientVolunteerAssignmentRequest {
    clientId: string;
}

export interface RemoveVolunteerAssignmentRequest {
    clientId: string;
}

/**
 * ClientVolunteerAssignmentsApi - interface
 * 
 * @export
 * @interface ClientVolunteerAssignmentsApiInterface
 */
export interface ClientVolunteerAssignmentsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {AssignVolunteerRequest} assignVolunteerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientVolunteerAssignmentsApiInterface
     */
    assignVolunteerToClientRaw(requestParameters: AssignVolunteerToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    assignVolunteerToClient(requestParameters: AssignVolunteerToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientVolunteerAssignmentsApiInterface
     */
    getClientVolunteerAssignmentRaw(requestParameters: GetClientVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientVolunteerAssignmentResponse>>;

    /**
     */
    getClientVolunteerAssignment(requestParameters: GetClientVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientVolunteerAssignmentResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientVolunteerAssignmentsApiInterface
     */
    removeVolunteerAssignmentRaw(requestParameters: RemoveVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    removeVolunteerAssignment(requestParameters: RemoveVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ClientVolunteerAssignmentsApi extends runtime.BaseAPI implements ClientVolunteerAssignmentsApiInterface {

    /**
     */
    async assignVolunteerToClientRaw(requestParameters: AssignVolunteerToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling assignVolunteerToClient().'
            );
        }

        if (requestParameters['assignVolunteerRequest'] == null) {
            throw new runtime.RequiredError(
                'assignVolunteerRequest',
                'Required parameter "assignVolunteerRequest" was null or undefined when calling assignVolunteerToClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/volunteer-assignment`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssignVolunteerRequestToJSON(requestParameters['assignVolunteerRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assignVolunteerToClient(requestParameters: AssignVolunteerToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignVolunteerToClientRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getClientVolunteerAssignmentRaw(requestParameters: GetClientVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientVolunteerAssignmentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientVolunteerAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/volunteer-assignment`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientVolunteerAssignmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientVolunteerAssignment(requestParameters: GetClientVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientVolunteerAssignmentResponse> {
        const response = await this.getClientVolunteerAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeVolunteerAssignmentRaw(requestParameters: RemoveVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling removeVolunteerAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/volunteer-assignment`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeVolunteerAssignment(requestParameters: RemoveVolunteerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeVolunteerAssignmentRaw(requestParameters, initOverrides);
    }

}
